import ELInspectionsCreateFolderModal from "./ELInspectionsCreateFolderModal";

export default ELInspectionsCreateFolderModal;
